import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const faqs = [
  {
    question: "Quanto tempo demora um reparo de celular?",
    answer: "O tempo varia conforme o tipo de reparo. Trocas de tela e bateria geralmente são realizadas em 1 a 2 horas. Reparos mais complexos podem levar de 24 a 48 horas. Sempre informamos o prazo estimado no diagnóstico."
  },
  {
    question: "Vocês oferecem garantia nos serviços?",
    answer: "Sim! Todos os nossos serviços possuem garantia. Trocas de peças têm garantia de 90 dias, e serviços de manutenção têm garantia de 30 dias. A garantia cobre defeitos relacionados ao serviço realizado."
  },
  {
    question: "Trabalham com peças originais?",
    answer: "Trabalhamos com peças originais e peças de alta qualidade (compatíveis). Sempre informamos as opções disponíveis e a diferença de preço, para que você possa escolher a melhor opção para seu orçamento."
  },
  {
    question: "Quanto custa para formatar um computador?",
    answer: "O valor da formatação depende dos serviços inclusos (backup de dados, instalação de programas, etc.). Entre em contato pelo WhatsApp para um orçamento personalizado e sem compromisso."
  },
  {
    question: "Vocês consertam relógios Garmin?",
    answer: "Sim! Somos especialistas em relógios Garmin. Realizamos troca de bateria, tela, botões, e restauração de software em diversos modelos como Fenix, Forerunner, Venu, entre outros."
  },
  {
    question: "Atendem empresas?",
    answer: "Sim! Oferecemos atendimento corporativo com condições especiais para empresas. Realizamos manutenção de frota de dispositivos, contratos de suporte e criação de sites empresariais."
  },
  {
    question: "Como funciona o orçamento?",
    answer: "O orçamento é gratuito e sem compromisso. Você pode trazer seu dispositivo para diagnóstico presencial ou enviar fotos/descrição do problema pelo WhatsApp para uma avaliação prévia."
  },
  {
    question: "Qual é o horário de funcionamento?",
    answer: "Funcionamos de segunda a sexta das 9h às 18h, e aos sábados das 9h às 14h. Para atendimento fora do horário comercial, entre em contato pelo WhatsApp."
  },
];

export const FAQ = () => {
  return (
    <section id="faq" className="section-dark py-24 md:py-32" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="text-[#00F0FF] text-sm font-mono uppercase tracking-widest">
            [ Dúvidas Frequentes ]
          </span>
          <h2 className="font-orbitron text-3xl md:text-4xl lg:text-5xl font-bold text-white mt-4 mb-6">
            Perguntas <span className="text-[#00F0FF]">Frequentes</span>
          </h2>
          <p className="text-[#94A3B8] text-lg max-w-2xl mx-auto font-space">
            Tire suas dúvidas sobre nossos serviços. Se não encontrar o que procura, fale conosco pelo WhatsApp.
          </p>
        </motion.div>

        {/* FAQ Accordion */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`} 
                className="faq-item bg-[#0A0A0A] px-6"
                data-testid={`faq-item-${index}`}
              >
                <AccordionTrigger className="text-left font-rajdhani font-semibold text-white hover:text-[#00F0FF] py-5 text-base">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-[#94A3B8] font-space text-sm leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
